// extracted by mini-css-extract-plugin
export default {"Label":"_Label--NInWz","Actions":"_Actions--XBEXV"};